import { render, staticRenderFns } from "./Ag-money.vue?vue&type=template&id=6164c002&"
import script from "./Ag-money.vue?vue&type=script&lang=js&"
export * from "./Ag-money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports